import React, { useState } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import styled from 'styled-components';
import {isMobile } from 'react-device-detect';
import Flexibility from '../assets/flexibility.png';

import File_445B from '../assets/445B.pdb';
import File_0_400 from '../assets/0_4000_100_B.pdb';


import {runFlexibility} from '../actions';
import WaitModal from './waitModal';
import ResultsModal from './resultsModal';





function FlexibilityTool(props) {

  const [mergeFile, setMergeFile] = useState('');
  const [modalIsOpen, setIsOpen] = useState(false);
  const [resultsModalIsOpen, setResultsOpen] = useState(false);
  const [jsonData, setJsonData] = useState({
    totalVariance: 'total variance: 12345678.10123456',
     averageVariance: 'average variance: 12345678901234567890.1234567890',
     res_3d_sd: '3d_sd(Euclidian Distance): 12345678901234567890.1234567890 ' })


  function openModal() {
    setIsOpen(true);
  }

  function closeModal(res) {
    console.log("this is res");
    console.log(res);
    setJsonData(res);
    setIsOpen(false);
    //open
    openResultsModal();

  }

  function closeResultsModal() {
    setResultsOpen(false);
  }

  function openResultsModal(){
    setResultsOpen(true);
  }


  const PostValues = ()=> {
     openModal();

     const {runFlexibility} = props;

     runFlexibility(mergeFile, (res)=>closeModal(res));
  };



  return (
    <Container>
      <HeaderContainer>
        <Desc>The flexibility calculation tool is to evaluate the flexibility of a single residue or a whole protein. </Desc>

      </HeaderContainer>

      <SubContainer>
        <Img src={Flexibility}/>
        <InputContainer>
        <Title>For a single residue: </Title>
        <ol>
          <Li>
            Get the trajectory of your MD simulation and align all the structures, you may use Chimera
            (<a href="https://www.cgl.ucsf.edu/chimera/">https://www.cgl.ucsf.edu/chimera/</a>) “MatchMaker” tool for structure alignments
          </Li>
          <Li>Select one particular residue, and save a PDB file, e.g. <a href={File_445B}>445B.pdb</a> (sample PDB contains 50 structures) </Li>
          <Li>Upload your PDB file here to get your flexibility of a single residue </Li>
        </ol>
        <Title>For a whole protein</Title>
        <ol>
          <Li>
            Get the trajectory of your MD simulation and align all the structures, you may use Chimera
             (<a href="https://www.cgl.ucsf.edu/chimera/">https://www.cgl.ucsf.edu/chimera/ </a>) “MatchMaker” tool for structure alignments
          </Li>
          <Li>Save the aligned structure into one PDB file, e.g.<a href={File_0_400}>0_4000_100_B.pdb</a>
          (sample PDB contains 50 selected structures from 4000 frames)
          </Li>
          <Li>Upload your PDB file here to get your flexibility of a single residue </Li>
        </ol>

        <Form>

          <Label>
            Upload PDB file:
            <input onChange={event => setMergeFile(event.target.files[0])} type="file" name="mergeFile" accept=".pdb" />
          </Label>
        </Form>
          <Button color="#7eb35b" marginTop="20px" onClick={()=>PostValues()}> Submit </Button>
         </InputContainer>
      </SubContainer>
      <WaitModal modalIsOpen={modalIsOpen} closeModal={()=>closeModal()} />
      <ResultsModal modalIsOpen={resultsModalIsOpen} closeModal={()=>closeResultsModal()} jsonData={jsonData} />
    </Container>

  );
}

const Container = styled.div`
  family-font:'Fira Sans';
`;

const SubContainer = styled.div`
  display: flex;
  flex-direction: ${props=> props.isMobile ? "column" : "row"};
  justify-content: space-around;
  align-items:center;

`;

const InputContainer = styled.div`
  margin-left:40px;
`;

const Img = styled.img`
	height: 31vw;
  max-width:652px;
`;

const Title = styled.p`
  font-weight:bold;
`;


const Form = styled.form`
  display:flex;
  flex-direction:column;
`;

const Label = styled.label`
  display:flex;
  flex-direction:column;
  font-size:15px;
`;


const Li = styled.li`
  font-size:17px;
`;

// const Input = styled.input`
//   background: transparent;
//   border-radius: 5px;
//   border: 1px solid #0095FF;
// `;


const Button = styled.button`
		border: none;
		width: 200px;
		height:50px;
		margin-right:10px;
		color: #fff;
		background-color: ${props => props.color};
		font-size: 1.2em;
		transform-style: preserve-3d;
		outline: none;
		cursor: pointer;
		border-radius: 0.27em;
		text-align: center;
		font-family:'Fira Sans';
    box-shadow: 2px 4px 6px rgb(0 0 0 / 30%);
    margin-bottom:${props => props.marginBottom};
    margin-top:${props => props.marginTop};
`;



  //background-color: #69ACC7;


const Desc = styled.div`
    font-size:22px;
    margin-bottom:40px;
`;

const HeaderContainer = styled.div`
  display:flex;
  width: 100%;
  justify-content:space-between;
  align-items:center;
  font-size:18px;
`;



const mapDispatchToProps = dispatch => {

  return bindActionCreators({runFlexibility}, dispatch);

};


export default connect(null,mapDispatchToProps)(FlexibilityTool);



// WEBPACK FOOTER //
// ./src/components/flexibilityTool.js